import { useMemo } from "react";
import moment from "moment";
import { DateFormats } from "../../components/constants/securspace-constants";

type DateFormat = typeof DateFormats[keyof typeof DateFormats];

/**
 * Today plus `amount` `unit`s (negative for the past), formatted with `dateFormat`.
 * `amount` and `unit` are the first two arguments of moment's `add()`.
 * Computed once per argument change, so it does not roll over at midnight while mounted.
 */
const useGetRelativeDate = (
  amount: moment.DurationInputArg1,
  unit: moment.DurationInputArg2,
  dateFormat: DateFormat
): string => {
  return useMemo(() => moment().add(amount, unit).format(dateFormat), [amount, unit, dateFormat]);
}

export {
  useGetRelativeDate,
  DateFormats,  // re-exported so consumers can get both the hook and the formats from the same place
  type DateFormat,
};
